export const epochFormatter = (date: number) => {
  return new Date(date * 1000);
};
